import React, { useMemo } from 'react';
import { DateTime } from 'luxon';
import { LettingWidgetBase } from '../LettingWidgetBase/LettingWidgetBase';
import styles from './ManageBookingsWidget.module.scss';
export const ManageBookingsWidget = ({ startDate, endDate, onClick, isClosed = false, }) => {
    const numberOfNights = useMemo(() => {
        const start = DateTime.fromISO(startDate);
        const end = DateTime.fromISO(endDate);
        return end.diff(start, 'days').days;
    }, [startDate, endDate]);
    const formattedStartDate = useMemo(() => DateTime.fromISO(startDate).toFormat('ccc dd LLL'), [startDate]);
    const formattedEndDate = useMemo(() => DateTime.fromISO(endDate).toFormat('ccc dd LLL'), [endDate]);
    return (<LettingWidgetBase iconUrl='https://www.haven.com/assets/owners/lettings/calendar-add.svg' title='Manage bookings' isClosed={isClosed} onClick={onClick} subtitle='Upcoming'>
      <div className={styles.contentWrapper}>
        <div className={styles.bookingDetail}>
          <p>
            {formattedStartDate} - {formattedEndDate}
          </p>
          <p>({numberOfNights} nights)</p>
        </div>
      </div>
    </LettingWidgetBase>);
};
